import React, { useEffect, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import { setModalPrincipal } from "../../shared/slice/ModalLogin/ModalLoginSlice";
import { useSelector } from "react-redux";
import ModalPrincipal from "../Modals/ModalPrincipal";
import { store } from "../../shared";
import ModalLogin from "../Modals/ModalLogin";
import ModalSignup from "../Modals/ModalSignup";
import ModalEmailSend from "../Modals/ModalEmailSend";
import { disconnect } from "../../shared/slice/auth/AuthSlice";
import styled from "styled-components";
import PersonIcon from "@mui/icons-material/Person";
import Cart from "../Cart/Cart";

import { useLocation, useNavigate } from "react-router-dom";
import Notification from "../Notification/notification";
import SideNavBar from "./SideNavBar";
import ModelGuest from "../Modals/ModelGuest";
import LogoEatorder from "../../assets/images/eatorder-logo.png";
import { setScroll } from "../../shared/slice/scroll/ScrollSlice";
import { ClickAndCollect } from "../../assets/images/exports";
export default function MyNavBar() {
  const isLoggedIn = useSelector((state) => state.authentification.isLoggedIn);
  const orders = useSelector((state) => state.order.order);
  const selectedPromos = useSelector((state) => state.promos.selectedPromos);

  const openmodal = () => {
    store.dispatch(setModalPrincipal({ modalPrincipal: true }));
  };
  const logout = () => {
    store.dispatch(disconnect());
    localStorage.clear();
  };

  const navigate = useNavigate();
  const selectedRestaurant = useSelector(
    (state) => state.restaurant.restaurantSelected._id
  );
  const RestaurantSlug = useSelector(
    (state) => state.restaurant.restaurantSelected.slug
  );
  const user = useSelector((state) => state.authentification.loggedInUser);

  const location = useLocation();
  const { delivery } = location.state || {};
  const [selectOption, setSelectOption] = useState(null);
  useEffect(() => {
    if (location.pathname.includes("history")) {
      setSelectOption({
        value: "History",
        label: "History",
        icon: "HistoryIcon",
      });
    } else if (location.pathname.includes("favorites")) {
      setSelectOption({
        value: "Favorite",
        label: "Favorite",
        icon: "StarBorderIcon",
      });
    } else {
      setSelectOption({
        value: user?.firstName,
        label: user?.firstName,
        icon: "ManageAccountsIcon",
      });
    }
  }, [user]);

  const Notifications = useSelector(
    (state) => state.ModalNotification.Notification
  );

  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    function countReadNotifications(Notifications) {
      return Notifications.reduce((readCount, notification) => {
        return notification.read === false ? readCount + 1 : readCount;
      }, 0);
    }

    const unread = countReadNotifications(Notifications);
    setUnreadCount(unread);
  }, [Notifications]);

  const goToStores = () => {
    if (location.pathname === `/ordershistory/${selectedRestaurant}`) {
      store.dispatch(setScroll({ scroll: 1 }));
      if (delivery === undefined) {
        navigate(`/${RestaurantSlug}`);
      } else {
        navigate(`/${RestaurantSlug}`, { state: { delivery: false } });
      }
    } else {
      if (delivery === undefined) {
        navigate("/");
      }
    }
  };

  return (
    <>
      <StyledNavbar
        className="bg-body-tertiary "
      >
        <StyledContainer>
          <Navbar.Brand>
            <div style={{ display: "flex" }}>
              <LogoContainer>
                <LogoImage03
                  src={LogoEatorder}
                  alt="Eatorder Logo"
                  onClick={goToStores}
                />
              </LogoContainer>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            {!isLoggedIn && (
              <Nav.Item className="text-white" data-testid="person-icon">
                {delivery === undefined && (
                  <button
                    className="btn"
                    onClick={() => openmodal()}
                    style={{ marginRight: "2px", padding: "0" }}
                  >
                    <PersonIcon style={{ color: "var(--primaryColor)" }} />
                    <span className="login-button"></span>
                  </button>
                )}
                <ModalPrincipal />
                <ModalLogin />
                <ModelGuest />
                <ModalSignup />
                <ModalEmailSend />
              </Nav.Item>
            )}
            {isLoggedIn && (
              <Nav.Item>
                <CardBadgeContainer data-testid="notif-icon">
                  <Notification />
                  {unreadCount > 0 && (
                    <CardBadge>
                      <div>{unreadCount}</div>
                    </CardBadge>
                  )}
                </CardBadgeContainer>
              </Nav.Item>
            )}
            <Nav.Item>
              <CardBadgeContainer data-testid="cart-icon">
                <Cart />

                {(orders.length > 0 || selectedPromos.length > 0) && (
                  <CardBadge>
                    <div>
                      {orders.reduce(
                        (total, order) => total + order.quantity,
                        0
                      ) +
                        selectedPromos.reduce(
                          (total, promo) => total + promo.promo.numberGroup,
                          0
                        )}
                    </div>
                  </CardBadge>
                )}
              </CardBadgeContainer>
            </Nav.Item>
            <Nav.Item>
              <CardBadgeContainer data-testid="side-icon">
                <SideNavBar />
              </CardBadgeContainer>
            </Nav.Item>
          </Navbar.Collapse>
        </StyledContainer>
      </StyledNavbar>
    </>
  );
}

const StyledContainer = styled(Container)`
  max-width: 97% !important;
`;

export const StyledNavbar = styled(Navbar)`
  position: sticky !important;
  top: 0px !important;
  z-index: 1002;
`;
const Logo = styled.img`
  height: 25px;
  @media (max-width: 450px) {
    height: 18px;
  }
`;
const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const LogoImage02 = styled.img`
  height: 25px;
  margin-left: 8px;

  @media (min-width: 768px) {
    height: 30px;
    margin-left: 40px;
  }
`;
const LogoImage03 = styled.img`
  height: 18px;
  margin-left: 2px;
`;
const CardBadgeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #eb1700;
`;

const CardBadge = styled.h6`
  min-width: 20px;
  min-height: 20px;
  background-color: #000;
  border-radius: 50%;
  text-align: center;
  margin-left: -10px;
  color: #fff;
`;
